import { render, staticRenderFns } from "./downloads.vue?vue&type=template&id=dc380a7a&scoped=true"
import script from "./downloads.vue?vue&type=script&lang=js"
export * from "./downloads.vue?vue&type=script&lang=js"
import style0 from "./downloads.vue?vue&type=style&index=0&id=dc380a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc380a7a",
  null
  
)

export default component.exports